import styled, { css } from "styled-components";

interface IContainer {
  loading?: boolean;
}

export const Container = styled.div<IContainer>`
  padding: 27px 31px 20px 34px;
  max-height:  312px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  ${({ loading }) => loading && css`
    overflow-y: hidden;
  `}

  .newUsersWrapper {
    display: flex;
    justify-content: space-between;

    .convertionToPremiumModal {
      position: absolute;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-left: -34px;
      z-index: 1;
      background: rgba($color: ${({ theme }) => theme.colors.surface.surfaceContainer}, $alpha: 0.85);
  
      .primaryTextConvertion{
        font-size: 14px;
        font-weight: 700;
        line-height: 21px;
        color: ${({ theme }) => theme.colors.primary.primary};
        margin: 0px;
      }
  
      .secondaryTextConvertion{
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        margin: 0px;
      }
    }

    .inputEmail {
      margin-bottom: 0;
      margin-right: 15px;
      width: 100%;

      input {
        padding-left: 24px;
      }
    }

    .buttonNewUser {
      font-size: 12px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.primary.onPrimary};
    }
  }

  .permissionsHintWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    padding: 0 0 22px 0;
    cursor: default;

    .hintText {
      padding: 23px;
      width: 323px;
    }

    .iconInfo {
      transition: color ease 0.3s;
      &:hover {
        color: ${({ theme }) => theme.colors.primary.primary} !important;
      }
    }
  }

  .titleSharedUserList {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    padding-bottom: 19px;
  }

  .titleSharedUserListFreemium {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
    margin-top: -19px;
    margin-bottom: 16px;
  }

  .TopbarInput {
    width: 100%;
    height: 42px;
    display: flex;
    border-radius: 2px;
    border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
    background-color: ${({ theme }) => theme.colors.surface.surface};
    margin-top: -12px;
    
    &:focus-within {
      border: 1px solid ${({ theme }) => theme.colors.primary.primary};
    }
    
    .TopbarInputSearch {
      margin-left: 6px;
      margin-right: 36px;
    }
  }

  .mainWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 22px;

    .textBottomHead {
      font-size: 14px;
      font-weight: 600;
      line-height: 19px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
    }

    .textBottomFooter {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      margin-top: 6px;
    }
  }

  .sharedUserItem {
    display: flex;
    margin-top: 6px;
    margin-right: 0;
    width: 100%;

    .invitedUserWrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding-right: 19px;
      padding-left: 28px;

      button {
        margin-left: 13px;
      }

      .invitedUserName, .sharedUserName {
        font-size: 12px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        padding-left: 26px;
        flex: 1;
      }
  
      .sharedRoleName {
        flex: 1 1;
        height: 35px;
        max-width: 160px;
        margin-right: 10px;
        text-align: center;
        padding-top: 6px;
        border-radius: 2px;
        border: 2px solid ${({ theme }) => theme.colors.surface.surfaceOutline} !important;

        font-size: 12px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      }

      .shareButton {
        width: 147px;
        display: flex !important;
        justify-content: center;
        align-items: center;
        font-size: 12px !important;

        &.shared {
          border: 2px solid ${({ theme }) => theme.colors.success.success};
          color: ${({ theme }) => theme.colors.success.success} !important;
          &:hover,
          &:focus {
            border-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.success.successOutline}, ${theme.colors.surface.surface})`};
          }
        }

        &:hover {
          background: ${({ theme }) => theme.colors.surface.surfaceContainer} !important;
        }

        > span {
          display: flex !important;
          align-items: center;
        }
      }
    }

    .selectionsWrapper {
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;

      .waitingButton {
        height: 32px;
        margin-left: 13px;
        display: flex;

        .waitingTitle {
          padding: 6px 18px;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 12px;
          color: ${({ theme }) => theme.colors.warning.warning};
          user-select: none;
          cursor: default;

          border: 2px solid ${({ theme }) => theme.colors.warning.warning};
          border-radius: 2px;
        }

        .buttonRemoveUser {
          width: 34px;
          margin: 0;
          border-left: none !important;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            border-left: none !important;
          }
          &:active {
            border-left: none !important;
          }
        }
      }
    }
  }

  .selectRole {
    width: fit-content !important;
    margin-right: 13px !important;
    border-width: 2px !important;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;

    > div:focus {
      outline-color: ${({ theme }) => theme.colors.primary.primary} !important;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
    }

    > div {
      width: 160px !important;
    }

    > div:first-child {
      height: 35px !important;
      border: 2px solid ${({ theme }) => theme.colors.surface.surfaceOutline} !important;
      border-radius: 2px !important;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;

      div {
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      }
    }
  }

  .button {
    padding: 0 40px !important;
    margin: 17px;
  }
`;
